import t from "./Calendar.js";
import { CONTROLS_ALL as a, CONTROLS_MINIMAL as O, CONTROLS_NONE as i, SELECT_ONE as E, SELECT_MANY as u, SELECT_NONE as n, RANGE_FROM as c, RANGE_TO as m } from "../constants.js";
import s, { UNBOUNDED_SLICE as L, sinceNow as f, untilNow as _ } from "../timeslice/index.js";
import { struct as l } from "../../../../../utils/struct/main.js";
import { isNumber as v, isFunction as d } from "../../../../../utils/value/is.js";
import { ALREADY_RESOLVED_PROMISE as p } from "../../../../../utils/async/constants.js";
import { enumerable as N } from "../../../../../utils/struct/property.js";
const b = Object.defineProperties((e) => {
  const { grid: r, kill: o } = new t();
  return v(e) ? r.config({ blocks: e }) : d(e) ? p.then(() => {
    r.config.watch = e;
  }) : r.config(e), l({
    grid: N(r),
    kill: N(o)
  });
}, {
  controls: {
    value: l({
      ALL: { value: a },
      MINIMAL: { value: O },
      NONE: { value: i }
    })
  },
  highlight: {
    value: l({
      ONE: { value: E },
      MANY: { value: u },
      NONE: { value: n }
    })
  },
  slice: {
    value: Object.defineProperties(s.bind(null), {
      FROM: { value: c },
      TO: { value: m },
      UNBOUNDED: { value: L },
      SINCE_NOW: { get: f },
      UNTIL_NOW: { get: _ }
    })
  }
});
export {
  b as default
};
